import { ProjectCard, useText } from '@kkf/design'
import { PROJECTS } from '../data/projects'
import { useT } from '../i18n'

/** The projects page. */
export function ProjectsPage() {
  const t = useT()
  const s = useText()
  return (
    <>
      {/*
        No banner and no breadcrumb (2026-09-21), the way `/about`, `/contact`, `/blog` and
        the legal pair lost theirs. `Breadcrumb` IS the photographic band — the trail sat
        inside it — so both went together. Two things travel with that, and each passes
        every gate this repo has:

        1. **It carried the page's only `<h1>`.** `audit:seo` fails a page with any number
           other than one, so the title is `.ul-plain-page-title` here — the class that
           exists for exactly this, beside `.ul-plain-page-top` in `_header.scss`.
        2. **The page now opens pale**, and the header's links are white at rest because
           the usual first section is a dark band. This route is in `header.plainRoutes`
           in `data/shell` as of the same day. Forget that and every link in the nav is
           white on near-white, and nothing anywhere goes red.
      */}
      <section className="ul-plain-page-top ul-projects ul-section-spacing">
        <div className="ul-container">
          <h1 className="ul-plain-page-title">{t('page.projects')}</h1>
          <div className="row ul-bs-row justify-content-center">
            {PROJECTS.map(({ colClassName, ...project }, i) => (
              <div className={colClassName} key={`${project.image}-${i}`}>
                {/* The card takes plain strings; the entry carries both languages. */}
                <ProjectCard
                  {...project}
                  title={s(project.title)}
                  descr={s(project.descr)}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
